/**
 * Compact, week-aware duration formatter used everywhere we render a job
 * duration — matches the spec table from WRK-5451. Breaks down to
 * Wk / Day / Hr / Min and skips zero parts.
 *
 * e.g. 1 → "1 Min", 60 → "1 Hr", 90 → "1 Hr 30 Min",
 *      1440 → "1 Day", 10080 → "1 Wk", 11610 → "1 Wk 1 Day 1 Hr 30 Min".
 */
export function formatMinutesCompact(totalMinutes: number | null | undefined): string {
  if (totalMinutes == null || !Number.isFinite(totalMinutes) || totalMinutes <= 0) return '—';

  const weeks = Math.floor(totalMinutes / 10080);
  const days = Math.floor((totalMinutes % 10080) / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = Math.floor(totalMinutes % 60);

  const parts: string[] = [];
  if (weeks > 0) parts.push(`${weeks} Wk`);
  if (days > 0) parts.push(`${days} Day`);
  if (hours > 0) parts.push(`${hours} Hr`);
  if (minutes > 0) parts.push(`${minutes} Min`);

  return parts.join(' ');
}
